import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
import { useGlobalScope } from '@shared/context/GlobalScopeContext';
import { useActiveOrganization } from '@shared/context/ActiveOrganizationContext';
export const useAccounts = () => {
    const queryClient = useQueryClient();
    const { scope } = useGlobalScope();
    const { activeOrganizationId, isLoadingOrganizations } = useActiveOrganization();
    const orgQueryReady = Boolean(activeOrganizationId) && !isLoadingOrganizations;
    const accountsQuery = useQuery({
        queryKey: ['accounts', activeOrganizationId, scope],
        enabled: orgQueryReady,
        queryFn: async () => {
            const { data } = await apiClient.get('/accounts', {
                params: { userId: scope }
            });
            return data;
        },
    });
    const createAccount = useMutation({
        mutationFn: async (dto) => {
            const { data } = await apiClient.post('/accounts', dto);
            return data;
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['accounts', activeOrganizationId] });
            }
        },
    });
    const updateAccount = useMutation({
        mutationFn: async ({ id, dto }) => {
            const { data } = await apiClient.patch(`/accounts/${id}`, dto);
            return data;
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['accounts', activeOrganizationId] });
            }
        },
    });
    /** Exclusão definitiva (soft-delete) — só permitida quando a conta não tem dados vivos (409 caso contrário). */
    const deleteAccount = useMutation({
        mutationFn: async (id) => {
            await apiClient.delete(`/accounts/${id}`);
        },
        onSuccess: () => {
            if (activeOrganizationId) {
                void queryClient.invalidateQueries({ queryKey: ['accounts', activeOrganizationId] });
            }
        },
    });
    return {
        ...accountsQuery,
        accounts: accountsQuery.data ?? [],
        createAccount,
        updateAccount,
        deleteAccount,
    };
};
